import {SkeletonBlock, desktopAndUpLinaria} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const ProductImageGridLoading = () => {
  return (
    <SkeletonWrapper>
      <ProductImageSkeleton />
      <ProductImageSkeleton />
      <ProductImageSkeleton />
      <ProductImageSkeleton />
      <ProductImageSkeleton />
      <ProductImageSkeleton />
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`;

const ProductImageSkeleton = styled(SkeletonBlock)`
  aspect-ratio: 3 / 4;
  margin: 0;
  height: auto;

  ${desktopAndUpLinaria(`width: calc(50% - 2px);`)}
`;
